import "core-js/modules/es.json.parse.js";
// import MenuBox from "@/components/exam/MenuBox.vue";
import TestInstructions from "@/components/exam/TestInstructions.vue";
import { ElMessageBox, ElMessage, ElLoading } from "element-plus";
import { useRoute, useRouter } from "vue-router";
import { GetUserExamsApi, UserExamsPreApi, GetLockExamApi, LockExamApi, UnlockExamApi } from "@/api/examApi";
import { GetVocabularyExamsApi, SetVocabularyExamTimeApi } from "@/api/vocabularyApi";
import { nextTick, onBeforeUnmount, reactive, ref } from "vue";
let examId = "";
export default {
  components: {
    TestInstructions
  },
  setup() {
    onBeforeUnmount(() => {
      window.sessionStorage.removeItem("examLock" + examId);
      //解锁
      UnlockExamApi({
        bizId: examId
      });
    });
    let route = useRoute();
    let router = useRouter();
    let examInfo = reactive({});
    let examInfoShow = ref(false);
    let examLoading = ref(true);
    let {
      netState
    } = useListenNet(examInfo);
    //检查设备 数据
    let useableExam = useCheckUseableExam(route, router);
    //考试数据
    useGetExamInfo(useableExam, examInfo, examInfoShow, router, route, examLoading);
    //考试开始
    function examStart(data) {
      if (data) examInfo.items = data;
      //设置考试开始
      examInfoShow.value = false;
    }
    //考试结束
    function finishExam(info) {
      examLoading.value = true;
      //下一卷
      if (info && info.papers) {
        Object.assign(examInfo, info);
        if (examInfo.examType == 19) {
          examInfo.skill = "S9";
        } else {
          examInfo.skill = examInfo.skills[0];
        }
        nextTick(() => {
          examLoading.value = false;
        });
      }
      //结束考试
      else {
        let key = examInfo.skill;
        let url = "";
        //第三方
        if (route.query.appKey) {
          switch (key) {
            case "S0":
              {
                // url =
                //   "/gz/reports/third-user-vspt-new.html?examId=" +
                //   examId +
                //   "&userId=";
                //  examInfo.userId+
                "&appKey=" + route.query.appKey;
                break;
              }
            case "S1":
              {
                url = "/gz/reports/third-user-report-listen.html?skill=" + key + "&examId=" + examId + "&userId=" + examInfo.userId + "&appKey=" + route.query.appKey;
                break;
              }
            case "S2":
              {
                url = "/gz/reports/third-user-report-reading.html?skill=" + key + "&examId=" + examId + "&userId=" + examInfo.userId + "&appKey=" + route.query.appKey;
                break;
              }
            case "S3":
              {
                url = "/gz/reports/third-user-report-grammar.html?skill=" + key + "&examId=" + examId + "&userId=" + examInfo.userId + "&appKey=" + route.query.appKey;
                break;
              }
            case "S4":
              {
                url = "/gz/reports/third-user-report-writing.html?skill=" + key + "&examId=" + examId + "&userId=" + examInfo.userId + "&appKey=" + route.query.appKey;
                break;
              }
            case "S5":
              {
                url = "/gz/reports/third-user-report-oral.html?skill=" + key + "&examId=" + examId + "&userId=" + examInfo.userId + "&appKey=" + route.query.appKey;
                break;
              }
          }
          if (url) window.location.replace(url);
        } else if (examInfo.examType == 3 || examInfo.examType == 19) {
          router.replace("/examlist");
          return;
        } else {
          switch (key) {
            case "S0":
              {
                url = "/gz/reports/user-report-vspt.html?skill=" + key + "&examId=" + examId + "&userId=" + window.localStorage.getItem("fltrp-home-userId");
                break;
              }
            case "S1":
              {
                url = "/gz/reports/user-report-listen.html?skill=" + key + "&examId=" + examId + "&userId=" + examInfo.userId + "&appKey=" + route.query.appKey;
                break;
              }
            case "S2":
              {
                url = "/gz/reports/user-report-reading.html?skill=" + key + "&examId=" + examId + "&userId=" + examInfo.userId + "&appKey=" + route.query.appKey;
                break;
              }
            case "S3":
              {
                url = "/gz/reports/user-report-grammar.html?skill=" + key + "&examId=" + examId + "&userId=" + examInfo.userId + "&appKey=" + route.query.appKey;
                break;
              }
            case "S4":
              {
                url = "/gz/reports/user-report-writing.html?skill=" + key + "&examId=" + examId + "&userId=" + examInfo.userId + "&appKey=" + route.query.appKey;
                break;
              }
            case "S5":
              {
                url = "/gz/reports/user-report-oral.html?skill=" + key + "&examId=" + examId + "&userId=" + examInfo.userId + "&appKey=" + route.query.appKey;
                break;
              }
          }
          let info = JSON.parse(window.localStorage.getItem("gz-userInfo"));
          if (info.identity == "试测校") {
            ElMessage({
              type: "success",
              showClose: true,
              message: "感谢您的作答～"
            });
            router.replace("/examlist");
            return;
          }
          if (url) window.open(url);
          router.replace("/examlist");
        }
      }
    }
    return {
      examInfoShow,
      examInfo,
      examStart,
      finishExam,
      examLoading,
      netState
    };
  }
};
//前置 参数设备检查
function useCheckUseableExam(route, router) {
  examId = route.query.examid || route.query.examId;
  if (!examId) {
    ElMessageBox.confirm("信息错误!无法进入考试。", "提示", {
      confirmButtonText: "确认",
      showClose: false,
      showCancelButton: false,
      cancelButtonText: false
    }).then(() => {
      router.replace("/examlist");
    }).catch(() => {
      router.replace("/examlist");
    });
    return false;
  }
  //口语
  if (route.path.indexOf("oral") != -1 && !window.sessionStorage.getItem("oraltestPass")) {
    router.replace({
      path: "/oraltest",
      query: route.query
    });
    return 0;
  }
  return true;
}
//获取数据
function useGetExamInfo(useableExam, examInfo, examInfoShow, router, route, examLoading) {
  if (!useableExam) return 0;
  //获取考试信息
  function getUserExams() {
    GetUserExamsApi({
      examId
    }).then(UserExamsR => {
      loading.close();
      if (UserExamsR.status < 400) {
        Object.assign(examInfo, UserExamsR.data);
        if (examInfo.examType == 19) {
          examInfo.skill = "S9";
        } else if (examInfo.examType == 17 || examInfo.examType == 23) {
          if (examInfo.skills) {
            examInfo.skill = examInfo.skills[0];
          } else {
            examInfo.skill = examInfo.papers[0].skill;
          }
        } else if (examInfo.examType == 3) {
          if (examInfo.skills[0] == "S0") {
            examInfo.skill = "S9";
          } else if (examInfo.skills[0] == "S5" || examInfo.skills.length == 1) {
            examInfo.skill = examInfo.skills[0];
          } else if (examInfo.skills[0] == "S4" || examInfo.papers.length <= 2) {
            examInfo.skill = examInfo.skills[0];
          } else {
            examInfo.skill = "S9";
          }
        }
        if (!examInfo.subdivide) examInfo.subdivide = 3;
        //考试已经开始
        if (examInfo.status == 3 || examInfo.status == 5) {
          if (examInfo.skill == "S5") {
            ElMessageBox.alert("考试开始", "", {
              callback: () => {
                examLoading.value = false;
                examInfoShow.value = false;
              }
            });
          } else {
            examLoading.value = false;
            examInfoShow.value = false;
          }
        }
        //考试已经结束
        else if (examInfo.status == 7 || examInfo.status == 11) {
          ElMessageBox.confirm("考试已结束。", "提示", {
            confirmButtonText: "确认",
            showClose: false,
            showCancelButton: false,
            cancelButtonText: false
          }).then(() => {
            router.replace("/examlist");
          }).catch(() => {
            router.replace("/examlist");
          });
        } else {
          examLoading.value = false;
          examInfoShow.value = true;
        }
      } else {
        ElMessage({
          type: "error",
          showClose: true,
          message: UserExamsR.msg
        });
      }
    });
  }
  //获取词汇考试信息
  function getUserVocabularyExams() {
    GetVocabularyExamsApi({
      examId
    }).then(r => {
      loading.close();
      if (r.status < 400) {
        if (r.data) Object.assign(examInfo, r.data);
        examInfo.skill = "S0";

        //考试已经开始
        if (examInfo.startTime) {
          examLoading.value = false;
          examInfoShow.value = false;
        }
        //考试已经结束
        else if (examInfo.daojishi <= 0) {
          ElMessageBox.confirm("考试已结束。", "提示", {
            confirmButtonText: "确认",
            showClose: false,
            showCancelButton: false,
            cancelButtonText: false
          }).then(() => {
            router.replace("/examlist");
          }).catch(() => {
            router.replace("/examlist");
          });
        } else {
          examInfo.examId = examId;
          examLoading.value = false;
          examInfoShow.value = true;
        }
      } else {
        ElMessage({
          type: "error",
          showClose: true,
          message: r.msg
        });
      }
    });
  }
  //考试加锁
  function lockExam() {
    LockExamApi({
      bizId: examId
    });
    if (window.sessionStorage.getItem("examLock" + examId)) setTimeout(() => {
      lockExam();
    }, 90000);
  }
  function checkExam() {
    if (route.meta.skill == "S0") {
      getUserVocabularyExams();
      return 0;
    }
    UserExamsPreApi(examId).then(r => {
      if (r.status < 400) {
        getUserExams();
      } else {
        ElMessage({
          type: "error",
          showClose: true,
          message: "发生错误"
        });
        router.replace("/examlist");
      }
    });
  }
  //考试锁验证
  function checkLock() {
    if (window.sessionStorage.getItem("examLock" + examId)) {
      checkExam();
      return 0;
    }
    GetLockExamApi({
      bizId: examId
    }).then(r => {
      if (r.status == 0) {
        if (r.data.lock) {
          ElMessageBox.confirm("请不要同时在多个设备上进行考试！若要切换设备考试，请您关闭其它设备上正在考试的页面，隔90秒后重新进入。", "提示", {
            confirmButtonText: "确认",
            showClose: false,
            showCancelButton: false,
            cancelButtonText: false
          }).then(() => {
            route.query.appKey ? window.closed() : router.replace("/examlist");
          }).catch(() => {
            route.query.appKey ? window.closed() : router.replace("/examlist");
          });
        } else {
          window.sessionStorage.setItem("examLock" + examId, "1");
          checkExam();
          lockExam();
        }
      } else {
        checkExam();
      }
    }).catch(() => {
      checkExam();
    });
  }
  const loading = ElLoading.service({
    lock: true,
    text: "加载中..",
    background: "rgba(0, 0, 0, 0.7)"
  });
  checkLock();
}
//监听网络
function useListenNet(examInfo) {
  console.log(examInfo);
  let netState = ref(1);
  let focusNo = 3;
  function online() {
    netState.value = true;
    ElMessage({
      type: "success",
      showClose: true,
      message: "网络已连接。"
    });
    if (examInfo.skill == "S0") {
      setTimeout(() => {
        location.reload();
      }, 2000);
    }
  }
  window.addEventListener("online", online);
  function offline() {
    netState.value = false;
    ElMessage({
      type: "error",
      showClose: true,
      message: "网络已断开,请检查网络后继续作答。"
    });
    let timer = setInterval(() => {
      if (netState.value) {
        clearInterval(timer);
      } else {
        ElMessage({
          type: "error",
          showClose: true,
          message: "网络已断开,请检查网络后继续作答。"
        });
      }
    }, 10000);
  }
  window.addEventListener("offline", offline);
  function focus() {
    if (focusNo <= 0) {
      ElMessage({
        type: "warning",
        showClose: true,
        message: "考试期间请勿进行非考试操作"
      });
    } else {
      focusNo--;
    }
  }
  window.addEventListener("focus", focus, false);
  onBeforeUnmount(() => {
    window.removeEventListener("focus", focus, false);
    window.removeEventListener("offline", offline);
    window.removeEventListener("online", online);
  });
  return {
    netState
  };
}